module.exports = __webpack_public_path__ + "img/ico_verif.417a079d.svg";